import api from '../../utils/services/api';

import {
  waitingBankUsersActionError,
  waitingBankUsersActionLoading,
  waitingBankUsersActionSuccess,
} from '../ducks/waitingBankUsers';

export const waitingBankUsersFetchAction = (
  filter = {
    limit: 10,
    page: 1,
    search: '',
    DATAINICIAL: '',
    DATAFINAL: '',
  },
) => {
  return async (dispatch) => {
    dispatch(waitingBankUsersActionLoading());
    try {
      const response = await api.get(
        `usuario/listar/aguardando_banco_parceiro?search=${filter.search}&DATAINICIAL=${filter.DATAINICIAL}&DATAFINAL=${filter.DATAFINAL}&page=${filter.page}&limit=${filter.limit}`,
      );
      dispatch(waitingBankUsersActionSuccess(response.data));
    } catch (error) {
      dispatch(waitingBankUsersActionError(error?.response?.data?.mensagem));
    }
  };
};
